import main from './main';

function createEmployeeWithVaccineCardUpload(server, fullName) {
  server.create('user-document', 'asCovidVaccineCard', 'withAttachments', 'asReview', {
    user: server.create('user', 'asEmployee', { fullName }),
  });
}

function createEmployeeWithTestResultUpload(server, fullName) {
  server.create('user-document', 'asCovidTestResult', 'withAttachments', 'asReview', {
    user: server.create('user', 'asEmployee', { fullName }),
  });
}

export default function (server) {
  main(server);

  createEmployeeWithTestResultUpload(server, 'Ian Malcom');

  createEmployeeWithVaccineCardUpload(server, 'Crystal Dunn');
  createEmployeeWithVaccineCardUpload(server, 'Daniel Craig');
  createEmployeeWithVaccineCardUpload(server, 'Dzsenifer Marozsan');
  createEmployeeWithVaccineCardUpload(server, 'George Lazenby');
  createEmployeeWithVaccineCardUpload(server, 'Julie Ertz');
  createEmployeeWithVaccineCardUpload(server, 'Pierce Brosnan');
  createEmployeeWithVaccineCardUpload(server, 'Roger Moore');
  createEmployeeWithVaccineCardUpload(server, 'Saki Kumagai');
  createEmployeeWithVaccineCardUpload(server, 'Sam Kerr');
  createEmployeeWithVaccineCardUpload(server, 'Sean Connery');
  createEmployeeWithVaccineCardUpload(server, 'Timothy Dalton');
  createEmployeeWithVaccineCardUpload(server, 'Wendie Renard');
}
